import React, { useState } from "react";
import { MessageCircle, Send, User, Building2, FileText, Wand2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export const WhatsAppBookingForm = ({ pacchetto = "Generale", color = "#ff6b35" }) => {
  const [nome, setNome] = useState("");
  const [attivita, setAttivita] = useState("");
  const [problema, setProblema] = useState("");
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!nome.trim()) return;
    const msg = [
      `Ciao Riccardo! Ti scrivo dal sito schedabusiness.`,
      `Pacchetto di interesse: ${pacchetto}`,
      nome.trim() ? `Nome: ${nome.trim()}` : "",
      attivita.trim() ? `Attivita: ${attivita.trim()}` : "",
      problema.trim() ? `Problema: ${problema.trim()}` : "",
    ].filter(Boolean).join("\n");
    window.open(`https://wa.me/+393273839782?text=${encodeURIComponent(msg)}`, "_blank");
    setSent(true);
  };

  if (sent) {
    return (
      <div className="bg-green-50 border border-green-200 rounded-2xl p-6 text-center" data-testid="booking-success">
        <MessageCircle className="w-8 h-8 mx-auto mb-2" style={{ color }} />
        <p className="font-bold text-gray-900 font-google">Messaggio pronto!</p>
        <p className="text-sm text-gray-500 mt-1">Si aprira' WhatsApp. Riccardo ti rispondera' al piu' presto.</p>
      </div>
    );
  }

  return (
    <section className="py-14 bg-[#faf8f5]" data-testid="whatsapp-booking-section">
      <div className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2 font-google">
            Per te, un <span style={{ color }}>regalo</span>
          </h2>
          <p className="text-gray-500 text-sm">Compila il form e ti rispondiamo su WhatsApp in giornata</p>
        </div>

        {/* Regalo extra - Live con Fotografo Certificato */}
        <div className="bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-2xl p-5 mb-6 text-center">
          <div className="flex items-center justify-center gap-2 mb-2">
            <svg className="w-5 h-5 text-amber-500" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2z"/></svg>
            <span className="font-bold text-amber-800 text-sm font-google">REGALO ESCLUSIVO per te che sei appena iscritto</span>
            <svg className="w-5 h-5 text-amber-500" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2z"/></svg>
          </div>
          <p className="text-sm text-amber-900">
            Una <strong>consulenza live streaming</strong> con un <strong>Fotografo Google Street View Certificato</strong> dal 2017. Solo per te.
          </p>
        </div>
        <form onSubmit={handleSubmit} className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 space-y-4">
          <div>
            <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
              <User className="w-4 h-4" style={{ color }} /> Il TUO nome *
            </label>
            <input
              type="text"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              placeholder="Es. Mario Rossi"
              className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm outline-none focus:ring-2 focus:border-transparent"
              style={{ "--tw-ring-color": color + "40" }}
              required
              data-testid="booking-nome"
            />
          </div>
          <div>
            <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
              <Building2 className="w-4 h-4" style={{ color }} /> La TUA attivita'
            </label>
            <input
              type="text"
              value={attivita}
              onChange={(e) => setAttivita(e.target.value)}
              placeholder="Es. Ristorante Da Mario, Siena"
              className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm outline-none focus:ring-2 focus:border-transparent"
              data-testid="booking-attivita"
            />
          </div>
          <div>
            <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1.5">
              <FileText className="w-4 h-4" style={{ color }} /> Descrivi il TUO problema
            </label>
            <textarea
              value={problema}
              onChange={(e) => setProblema(e.target.value)}
              placeholder="Es. La mia scheda Google e' stata sospesa..."
              rows={3}
              className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm outline-none focus:ring-2 focus:border-transparent resize-none"
              data-testid="booking-problema"
            />
          </div>
          <Button
            type="submit"
            size="lg"
            className="w-full text-white rounded-full text-base font-bold"
            style={{ backgroundColor: color }}
            data-testid="booking-submit"
          >
            <Wand2 className="w-5 h-5 mr-2" /> Magic
          </Button>
          <p className="text-center text-xs text-gray-400">
            Risposta garantita in giornata · E' un regalo · Nessun impegno
          </p>
        </form>
      </div>
    </section>
  );
};
